import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import { EmailSettingsPayload } from 'app/types/settings/email'

export const createEmailSettings = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.settings.email.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = EmailSettingsPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const emailSettingsCreated = {
            id: 999,
            ...payloadParsed.data,
        }

        return HttpResponse.json(emailSettingsCreated, {
            status: StatusCodes.CREATED,
        })
    },
)
